import { useIntl } from '@capsicum/common';
import { HeaderBlock } from '@capsicum/common-web';
import {
	type FanTokenOfferingsSectionProps,
	useFanTokenOfferingSection,
	useFTOupdateFromWS
} from '@capsicum/features/fan-token-offering/shared';

import { FanTokenOfferingCard } from '../FanTokenOfferingCard';

/**
 * FanTokenOffering section used to display FTO cards carousel with a heading
 * @param {string} page page where the component is used for the testID of the component
 * @returns {JSX.Element} the FTO card carousel component
 */

export const FanTokenOfferingsSection = ({ page, partnerId }: FanTokenOfferingsSectionProps) => {
	const { $t } = useIntl();

	const { filteredFanTokenOfferings, refetch } = useFanTokenOfferingSection({
		partnerId
	});

	useFTOupdateFromWS(refetch);

	if (!filteredFanTokenOfferings?.length) {
		return null;
	}

	return (
		<div>
			<HeaderBlock
				testID={`${page}-fanTokenOfferingsCard-sectionTitle`}
				title={$t('fanTokenOffering.sectionTitle')}
			/>
			{filteredFanTokenOfferings?.map((offering, index) => (
				<FanTokenOfferingCard
					fto={offering}
					ftoIndex={index}
					key={offering.id}
					page={page}
					onElapsed={() => {
						setTimeout(() => {
							refetch();
						}, 10000);
					}}
				/>
			))}
		</div>
	);
};
